import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import classNames from 'classnames';
import { FunctionComponent, useId } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { InputSign } from '../../../../sharedComponents/InputSign';
import { TextInput } from '../../../../sharedComponents/sidebar/TextInput';

type LoadIdInputProps = {
    loadId: string | undefined;
    setLoadId: (value: string | undefined) => void;
    validationErrorMessageId: string | undefined;
    disabled: boolean;
};
export const LoadIdInput: FunctionComponent<LoadIdInputProps> = ({
    loadId,
    setLoadId,
    validationErrorMessageId,
    disabled,
}) => {
    const intl = useIntl();
    const inputId = useId();

    const hasError = validationErrorMessageId !== undefined;

    return (
        <div className={classNames('form-group', { 'has-feedback': hasError, 'has-error': hasError })}>
            <FormLabel htmlFor={inputId}>
                <FormattedMessage id="outboundOrderBook.compoundManagement.table.heading.loadId" />
            </FormLabel>
            <TextInput
                id={inputId}
                placeholder={intl.formatMessage({ id: 'outboundOrderBook.compoundManagement.enterLoadId' })}
                value={loadId ?? ''}
                setValue={setLoadId}
                hasError={hasError}
                disabled={disabled}
            />
            {hasError && <InputSign messageId={validationErrorMessageId} glyph="rioglyph-error-sign" />}
        </div>
    );
};
